import { render, staticRenderFns } from "./remoteSelect.vue?vue&type=template&id=54b956ad"
import script from "./remoteSelect.vue?vue&type=script&lang=js"
export * from "./remoteSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports